import type { TourStep } from '../types';

export const taxAppealSteps: TourStep[] = [
  {
    target: '[data-tour="tool-tax-appeal"]',
    title: 'Tax Appeal Feasibility',
    content:
      'This tool analyzes whether a property tax appeal is worth pursuing using NJ Chapter 123 Common Level Range data, the Director\'s Ratio, and recent comparable sales.',
    placement: 'bottom',
    route: '/appraisals/tools',
    nextButtonText: 'Open it',
  },
  {
    target: '[data-tour="tax-header"]',
    title: 'Tax Appeal Analyzer',
    content:
      'Search for any NJ property to get an instant feasibility assessment. The tool pulls current assessments, tax history, and Director\'s Ratio data automatically.',
    placement: 'bottom',
    route: '/appraisals/tools/tax-appeal',
  },
  {
    target: '[data-tour="tax-search"]',
    title: 'Find a Property',
    content:
      'Type an address to search. Try a property you\'re familiar with — the system will pull its current assessment, tax data, and comparable sales from county records.',
    placement: 'bottom',
    route: '/appraisals/tools/tax-appeal',
    isActionStep: true,
    spotlightClicks: true,
    nextButtonText: 'I\'ve searched',
  },
  {
    target: '[data-tour="tax-verdict"]',
    title: 'Review the Verdict',
    content:
      'The verdict shows whether an appeal has Strong, Moderate, or Weak feasibility — along with the estimated annual savings, assessment-to-market ratio, and Common Level Range position.',
    placement: 'bottom',
    route: '/appraisals/tools/tax-appeal',
  },
  {
    target: '[data-tour="tax-assumptions"]',
    title: 'Enter Your Market Opinion',
    content:
      'This is where you add your professional judgment. Enter a preliminary market value estimate and value range. For commercial properties, you can run a direct cap analysis too.',
    placement: 'top',
    route: '/appraisals/tools/tax-appeal',
    isActionStep: true,
    spotlightClicks: true,
    nextButtonText: 'I\'ve reviewed this',
  },
  {
    target: '[data-tour="tax-actions"]',
    title: 'Take Action',
    content:
      'From here you can create a full appraisal or engagement letter pre-filled with this property\'s data — no re-entry needed. Great for converting feasibility studies into assignments.',
    placement: 'top',
    route: '/appraisals/tools/tax-appeal',
    isActionStep: true,
    spotlightClicks: true,
  },
];
